export default "__VITE_ASSET__CjAw__Gu__"